export default __webpack_public_path__ + "static/media/extra-shot-of-pride.ef185c87.webp";